const Tools = ({ toolSection }) => {
  return (
    <div className="section__tools">
      <div className="section__tools__list">
        {toolSection.map((o, i) => {
          return (
            <div className="section__tools__link" id={`item-${i}`}>
              <p>{o?.toolDescription}</p>
              <a href={`${o?.toolLink}`}>
                {o?.toolTitle}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tools;
